"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class DropdownModule extends base_1.SelectModule {
    constructor() {
        super(...arguments);
        this._type = "Dropdown";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                actionRequired: this.actionRequired,
                id: this.id,
                label: this.label,
                options: this.options,
                style: this.style,
                required: this.required,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            if (this.hidden) {
                builderConfigModule.hidden = this.hidden;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const { required, label, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            actionRequired: this.actionRequired,
            header: { children: (_a = label === null || label === void 0 ? void 0 : label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
            options: this.options.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    hidden: !!opt.hidden,
                });
            }),
        };
        if (required) {
            surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            hidden: this.hidden,
            options: this.options.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    hidden: !!opt.hidden,
                });
            }),
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
        };
    }
}
exports.DropdownModule = DropdownModule;
//# sourceMappingURL=Dropdown.js.map